export default __webpack_public_path__ + "static/media/about_us_6.eba43297.jpeg";